














































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thequipment from "../../../store/entities/thequipment";
@Component
export default class EditThequipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  thequipment: Thequipment = new Thequipment();
  updateInt:number=0;
  selwarehouselist = [];
  selfloorlist = [];
  displaynone = "display:none";
  updateInterval = false;
  updateG = false;
  gflist=[];
  userName="0";
  seltime=[
    {value: 1,label: '1分钟'},
    {value: 5,label: '5分钟'},
    {value: 10,label: '10分钟'},
    {value: 15,label: '15分钟'},
    {value: 30,label: '30分钟'},
    {value: 60,label: '60分钟'},
    {value: 120,label: '120分钟'},
    {value: 240,label: '240分钟'},
    {value: 360,label: '360分钟'},
    {value: 720,label: '720分钟'},
    {value: 1440,label: '1440分钟'},
  ]
  save() {
    (this.$refs.thequipmentForm as any).validate(async (valid: boolean) => {
      this.getuserName();
      if (valid) {
        //this.thequipment.updateInterval = this.updateInt;
        //this.thequipment.updateG = this.updateG;
        if(this.updateInterval){
          this.thequipment.updateInterval=1;
        }else{
          this.thequipment.updateInterval=0;
        }
          if(this.updateG){
          this.thequipment.updateG=1;
        }else{
          this.thequipment.updateG=0;
        }
        await this.$store.dispatch({
          type: "thequipment/update",
          data: this.thequipment,
        });
        (this.$refs.thequipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  getuserName() {
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
      if(this.userName.includes("保定")){
        this.userName = "1";
      }else{
        this.userName = "0";
      }
    return this.userName;
  }
  get smokeleaf(){
    return this.$store.state.smokeleaf.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  get smokecrib(){
    return this.$store.state.smokecrib.leaffilterlist; 
  }
  get ththreshold(){
    return this.$store.state.ththreshold.list;
  }
  get gwequipment() {
    return this.$store.state.gwequipment.list;
  }
  selfactory(value:Number){
    this.thequipment.ftId = value;
    this.selgId();
    this.getwarehouse();
      this.getfloor();
  }
  selwarehouse(value:Number){
    this.thequipment.wId = value;
    this.getfloor();
  }
  selfloor(value:Number){
    this.thequipment.fId = value;
    // this.getsmokecrib();
  }
  selEth(){
    this.displaynone="display:none";

  }
  selth(){
    this.displaynone = "";
  }
   selgId(){
    var gwelist = this.$store.state.gwequipment.list;
    var faclist = this.$store.state.factory.list;
    var wlist = this.$store.state.warehouse.list;
    var flist = this.$store.state.floor.list;
    var globallist = [];
    for(var i=0;i<gwelist.length;i++){
      var gweId = gwelist[i].ftId;
      for(var j=0;j<faclist.length;j++){
        var facId = faclist[j].id;
        if(gweId == facId){
          globallist[i] = faclist[j].fName;
        }
      }
      for(var w=0;w<wlist.length;w++){
        if(gwelist[i].wId == wlist[w].id){
          globallist[i] = globallist[i] + wlist[w].wName;
        }
      }
      for(var f=0;f<flist.length;f++){
        if(gwelist[i].fId == flist[f].id){
          globallist[i] = globallist[i] + flist[f].fName;
        }
      }
      if(gwelist[i].frequency == null){
            this.gflist[i]={value:gwelist[i].id,label: globallist[i]};
          }
          else{
            this.gflist[i]={value:gwelist[i].id,label: globallist[i] + gwelist[i].frequency};
          }
    }
  }
  // selectCheckBoxI(e) {
  //     if(e.target.checked){
  //       this.updateInt = 1;
  //     }
  //   }
  //    selectCheckBoxG(e) {
  //   if(e.target.checked){
  //       this.updateG = 1;
  //     }
  //   }
 async getsmokecrib() {
   
    //烟垛
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getlistfilter",
       data: this.thequipment,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.thequipment,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getfilter",
      data: this.thequipment,
    });
  }
  cancel() {
    (this.$refs.thequipmentForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.thequipment = Util.extend(true, {}, this.$store.state.thequipment.editThequipment);
      this.selgId();
      if(this.thequipment.etype == 1){
        this.displaynone = "";
      }
      else{
        this.displaynone = "display:none";
      }
      if(this.thequipment.updateInterval==0){
        this.updateInterval=false;
      }else{
        this.updateInterval=true;
      }
       if(this.thequipment.updateG==0){
        this.updateG=false;
      }else{
        this.updateG=true;
      }
      this.selfactory(this.thequipment.ftId);
      this.selwarehouse(this.thequipment.wId);
      this.selfloor(this.thequipment.fId);
    }
  }
   thequipmentRule = {
     ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    // number: [{transform: (value) => String(value), required: true, message: "请填写位置编号", trigger: "blur" }],
    tId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    scId: [{type:'number', message: "请选择烟叶", trigger: "change" }],
    acquisitionInterval: [{type:'number',required: true, message: "请选择采集间隔", trigger: "change" }],
    // gId:[{type:"number",required:true,message:"请选择网关",trigger:"change"}]
  };
}
